import * as React from 'react';
import { ModalSize } from '@economic/gaudi';

import { SalesModalFormProps, SalesModalForm } from './SalesModalForm';
import { SendEmailOptionsDrawer, PdfAttachmentOptions, FullAttachmentOptions, EncryptOption } from './SendEmailOptionsDrawer';
import { emailOptionsValidationSchema } from '../../invoices/utils/emailOptionsValidationSchema';

type SalesModalFromWithEmailOptionsDrawerProps = Omit<SalesModalFormProps, 'drawer' | 'validationSchema'> & {
    hideRecipientsSection?: boolean;
    hideRemember?: boolean;
    fullEmailDrawerAttachmentsOptions?: boolean;
    hideAttachmentOptions?: boolean;
    size?: ModalSize;
};

export function SalesModalFormWithEmailOptionsDrawer({
    hideRecipientsSection,
    hideRemember,
    fullEmailDrawerAttachmentsOptions,
    hideAttachmentOptions,
    size,
    ...rest
}: SalesModalFromWithEmailOptionsDrawerProps) {
    return (
        <SalesModalForm
            drawer={formValues => (
                <SendEmailOptionsDrawer
                    hideRemember={!!hideRemember || formValues.hasEmailTemplates}
                    hideRecipientsSection={hideRecipientsSection}
                    hideESignatureSection={
                        !formValues ||
                        !formValues.orderSendESignatureRequest ||
                        !formValues.orderSendESignatureRequest.signingTemplateId ||
                        formValues.orderSendESignatureRequest.signingTemplateId === 'NOSIGNINGREQUIRED'
                    }>
                    {hideAttachmentOptions ? (
                        <EncryptOption />
                    ) : fullEmailDrawerAttachmentsOptions ? (
                        <FullAttachmentOptions />
                    ) : (
                        <PdfAttachmentOptions />
                    )}
                </SendEmailOptionsDrawer>
            )}
            validationSchema={emailOptionsValidationSchema()}
            size={size}
            {...rest}
        />
    );
}
